export function animateMapChanges() {
  return !globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches && !globalThis.document?.hidden;
}
